import { useState, useEffect } from 'react';
import axios from "axios";
import {useActiveWeb3React} from "./useActiveWeb3React";

export function useRss() {
    const [posts, setPosts] = useState([])
    const {account, chainId} = useActiveWeb3React()

    useEffect(() => {
        axios.get("https://account.swapnova.io/api/getrss")
            .then(res => {
                setPosts(res.data)
            })
    }, [])

    return posts
}